import React from 'react'
import cta_women from "../../Assets/cta_women.png";
import gplay from "../../Assets/gplay.png"
import qr from "../../Assets/qr.png"

export default function CtaSection() {
    return (
        <section className="bg-[#ffffff] py-16 md:py-24 font-inter px-6 md:0 ">
            <div className="mx-auto max-w-7xl bg-white py-20  mt-10">

                <header className="text-start mb-10">
                    <h2 className="font-spacegrotesk text-3xl md:text-5xl font-bold text-[#151515] leading-tight">
                        An Honourable Mobile <br className="hidden sm:block" />
                        Application
                    </h2>
                </header>


                <div className='relative rounded-3xl bg-gradient-to-r from-[#000856] to-[#101B8F]  md:overflow-visible'>
                    <div className="grid grid-cols-1 md:grid-cols-2 items-center">


                        <div className="flex flex-col sm:flex-row gap-8 items-center px-6 md:px-12 py-12 text-white z-10 text-center sm:text-start">
                            <div className="flex-shrink-0">
                                <img
                                    src={qr}
                                    alt="QR Code"
                                    className="w-56 h-56 md:w-60 md:h-60 bg-white p-3 hover:scale-105 transition-transform  rounded-lg  shadow-2xl mx-auto"
                                />
                            </div>

                            <div>
                                <h2 className="text-2xl md:text-4xl font-bold mb-3 font-spacegrotesk">
                                    Get The App
                                </h2>
                                <p className="text-sm md:text-lg text-gray-200 mb-6 max-w-[280px] mx-auto sm:mx-0">
                                    Scan the QR code to download the app instantly.
                                </p>
                                <div className="flex justify-center sm:justify-start">
                                    <a href='https://play.google.com/store/apps/details?id=com.app.bumppypayments'>
                                        <img src={gplay} alt='Google Play' className='h-12 object-contain hover:scale-105 transition-transform cursor-pointer' />
                                    </a>
                                </div>
                            </div>
                        </div>


                        <div className="relative flex justify-center items-end h-full">
                            <img
                                src={cta_women}
                                alt="model"
                                className="relative h-[350px] w-auto object-contain z-20 mt-[-20px] md:absolute md:bottom-0 md:right-0 lg:right-10 md:h-[450px] lg:h-[580px] md:mt-0"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}
